import { render, staticRenderFns } from "./FinishSetup.vue?vue&type=template&id=6a6e7060&"
import script from "./FinishSetup.vue?vue&type=script&lang=js&"
export * from "./FinishSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports